// extracted by mini-css-extract-plugin
export default {"walletPage":"WalletPage_walletPage__xiiJQ","mainArea":"WalletPage_mainArea__hv-n9"};